import { useQuery } from '@tanstack/react-query'
import type { ReactNode } from 'react'

import { fetchCopyShell } from './copy-fetch'
import { CopyContext } from './use-copy'

export function CopyProvider({ children }: { children: ReactNode }) {
  const { data, isError, refetch, isFetching } = useQuery({
    queryKey: ['copy', 'shell'],
    queryFn: fetchCopyShell,
    staleTime: Infinity,
    gcTime: Infinity,
  })

  if (isError) {
    return (
      <main className="flex min-h-screen items-center justify-center p-6">
        <div className="flex flex-col items-center gap-3 text-center">
          <p className="text-sm text-white/70">Nie udało się załadować treści.</p>
          <button
            type="button"
            onClick={() => refetch()}
            disabled={isFetching}
            className="rounded bg-white/10 px-4 py-2 text-sm"
          >
            spróbuj ponownie
          </button>
        </div>
      </main>
    )
  }

  if (!data) {
    return (
      <main className="flex min-h-screen items-center justify-center p-6">
        <p className="text-sm text-white/40">...</p>
      </main>
    )
  }

  return <CopyContext.Provider value={data}>{children}</CopyContext.Provider>
}
